module.exports = __webpack_public_path__ + "static/media/4Do4Dont_OnePage.63512b05.png";